import type { PreparedDestination, ExistingDestination } from '@prequel/react';

const API_KEY_PARAM = 'apiKey';
const RECIPIENT_ID_PARAM = 'recipientId';
const LS_API_KEY = 'prequel_api_key';
const LS_RECIPIENT_ID = 'prequel_recipient_id';
const ORIGIN = typeof window !== 'undefined' ? window.origin : '';

/**
 * Helper to get from URL or localStorage
 */
const getValueFromUrlOrStorage = (param: string, storageKey: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlValue = urlParams.get(param);

  if (urlValue) {
    localStorage.setItem(storageKey, urlValue);
    return urlValue;
  }

  return localStorage.getItem(storageKey);
};

export const getPrequelAPIKey = (): string | null => {
  return getValueFromUrlOrStorage(API_KEY_PARAM, LS_API_KEY);
};

export const getPrequelRecipientId = (): string | null => {
  return getValueFromUrlOrStorage(RECIPIENT_ID_PARAM, LS_RECIPIENT_ID);
};

export const fetchPrequelAuthToken = async (
  destination?: PreparedDestination | ExistingDestination,
): Promise<string> => {
  const apiKey = getPrequelAPIKey();
  const recipientId = getPrequelRecipientId();

  if (!apiKey || !recipientId) {
    console.error('Missing required values: apiKey or recipientId');
    return '';
  }
  try {
    const response = await fetch('https://api.prequel.co/actions/generate-scoped-auth-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-KEY': apiKey,
        'X-Prequel-Api-Version': '2023-12-01',
      },
      body: JSON.stringify({
        recipient_id: recipientId,
        application_origin: ORIGIN,
        destination: destination,
      }),
    });

    const {
      data: { scoped_token } = { scoped_token: null },
    } = await response.json();
    return scoped_token;
  } catch (error) {
    console.error('Failed to fetch scoped auth token:', error);
    return '';
  }
};
